import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function () {
  const sections = document.querySelectorAll('.faq-section');
  sections.forEach((section) => {
    const tabButtons = section.querySelectorAll('.project-type-btn');
    const singleFaqItems = section.querySelectorAll('.faq-item');
    const items = section.querySelectorAll('.faq-tab');

    tabButtons.forEach((tab) => {
      tab.addEventListener('click', toggleTab);
    });
    singleFaqItems.forEach((item) => {
      item.addEventListener('click', toggleItem);
    });

    function toggleTab(e) {
      e.preventDefault();
      const tabId = this.getAttribute('data-tab');

      tabButtons.forEach((tab) => {
        tab.classList.remove('active');
      });

      this.classList.add('active');

      items.forEach((item) => {
        (tabId == item.getAttribute('data-tab') || tabId == '') ? item.classList.remove('hide') : item.classList.add('hide')
      });
    }

    function toggleItem(e) {
      if (e) {
        section.querySelectorAll('.faq-item').forEach(item => {
          if (item != this) item.classList.remove('active');
        });
        this.classList.toggle('active');
      }

      gsap
        .to(section.querySelectorAll('.faq-item:not(.active) .faq-item__answer'), {
          height: 0,
          opacity: 0,
          duration: 0.3
        })

      if (section.querySelectorAll('.faq-item.active').length) {
        gsap.to(section.querySelectorAll('.faq-item.active .faq-item__answer'), {
          height: 'auto',
          opacity: 1,
          duration: 0.3,
        });
      }

      ScrollTrigger.refresh();
    }
  });
}